import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, setToken, errorText } from "@/lib/api";
import { Field, inputCls, PrimaryButton, errorCls } from "@/components/agent/ui";
import { Brand, LogoMark } from "@/components/agent/AgentLayout";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      navigate("/", { replace: true });
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative isolate flex min-h-screen flex-col overflow-x-clip bg-background">
      <header className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-4 md:px-8">
        <Link to="/welcome" aria-label="Landin home"><Brand /></Link>
        <Link to="/tenant" className="rounded-md px-2 py-1 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground" data-testid="login-tenant-link">I'm a tenant</Link>
      </header>
      <main className="flex flex-1 items-center justify-center px-6 pb-16">
        <div className="flex w-full max-w-sm flex-col gap-4">
          <Link to="/welcome" className="-ml-1 inline-flex w-fit items-center gap-1 rounded-md px-1 py-0.5 text-xs text-muted-foreground hover:text-foreground" data-testid="login-back">
            <ArrowLeft className="size-3.5" /> Back
          </Link>
          <form onSubmit={submit} className="flex w-full flex-col gap-6" data-testid="login-form">
            <div className="flex flex-col items-center gap-3 text-center" data-testid="landin-brand">
              <LogoMark className="size-10 rounded-xl text-lg" />
              <div>
                <h1 className="text-xl font-semibold">Sign in to Landin</h1>
                <p className="text-sm text-muted-foreground">See your properties and applicants.</p>
              </div>
            </div>
            <div className="flex flex-col gap-4">
              <Field label="Email">
                <input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="login-email-input" />
              </Field>
              <Field label="Password">
                <input id="password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="login-password-input" />
              </Field>
            </div>
            {error && <p className={`${errorCls} text-center`} data-testid="login-error">{error}</p>}
            <PrimaryButton type="submit" size="lg" isLoading={busy} testid="login-submit-button">Sign in</PrimaryButton>
          </form>
        </div>
      </main>
    </div>
  );
}
